<script>
import certificadosDigitais from "../../../api/certificados-digitais";
import Btn from "../../_www/Btn/Btn.vue";
import Modal from "../../Modal.vue";

export default {
  name: "ExcluirMetodoAutenticacao",
  components: {
    Btn,
    Modal
  },
  props: {
    certificadoId: {
      type: Number,
      required: true
    },
    origemTribunalSistemasIds: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      closeButton: false,
      loading: false,
      form: {
        frase: '',
        error: '',
      }
    }
  },
  computed: {
    formInvalido() {
      return this.form.frase !== 'DELETAR' || this.form.frase.length === 0
    }
  },
  methods: {
    fecharModal() {
      this.form.frase = '';
      this.form.error = '';
      this.$emit("closeModal");
    },
    onSubmit() {
      this.loading = true;
      this.closeButton = true;

      certificadosDigitais.deletarMetodoAutenticacao(this.certificadoId,  this.origemTribunalSistemasIds)
        .then(() => {
          this.form.error = '';
          window.location.reload();
        })
        .catch(() => {
          this.form.error = 'Não encontrado';
        })
        .finally(() => {
          this.loading = false;
          this.closeButton = false;
        });
    },
  }
}
</script>

<template>
  <modal
    size="small"
    ref="modal"
    :hideCloseButton="closeButton"
    @close-modal="fecharModal"
  >
    <div slot="header">
      Deseja excluir este método de autenticação?
    </div>
    <div class="container" slot="content">
      <p>Digite <b>DELETAR</b> para continuar:</p>
      <form id="form-certificado" @submit.prevent="onSubmit">
        <div class="form-box form-creditos mb-3">
          <label class="label form-label" for="senha">Texto</label>
          <input
            class="field name-w form-control max-width-responsiva"
            type="text"
            name="senha"
            id="senha"
            required="required"
            v-model="form.frase"
            autocomplete="off"
          />
        </div>
        <span v-if="form.error" class="Message -fail" v-text="form.error"></span>
        <Btn
          class="btn negative"
          type="submit"
          :loading="loading"
          :disabled="loading || formInvalido"
          @click="onSubmit"
        >
          <b>Excluir</b>
        </Btn>
      </form>
    </div>
    <div slot="footer"></div>
  </modal>
</template>

<style scoped lang="stylus">
</style>
